import { combineEpics } from 'redux-observable'
import viewContentCatalogEpic from './viewContentCatalog'
import viewContentProductEpic from './viewContentProduct'
import viewContentSaleHomeEpic from './viewContentSaleHome'

export default combineEpics(
  viewContentCatalogEpic,
  viewContentProductEpic,
  viewContentSaleHomeEpic
)
